import i18next from 'i18next';
import {
  type BulkOperationStreamError,
  BulkOperationStreamErrorCode,
} from 'api/services/bulkOperationService';
import type shellEn from 'locales/en/recruiter/shell.json';
import { SHELL_NS } from 'recruiter-i18n/namespaces/shell';
import { codedErrorDetailText } from 'utils/apiError';

const STREAM_ERROR_KEYS = {
  [BulkOperationStreamErrorCode.OPERATION_NOT_FOUND]:
    'bulkToast.error.notFound',
  [BulkOperationStreamErrorCode.STREAM_CANCELLED]: 'bulkToast.error.connection',
  [BulkOperationStreamErrorCode.STREAM_FAILED]: 'bulkToast.error.connection',
  [BulkOperationStreamErrorCode.HTTP_ERROR]: 'bulkToast.error.connection',
  [BulkOperationStreamErrorCode.CONNECTION_FAILED]:
    'bulkToast.error.connection',
  [BulkOperationStreamErrorCode.ENDED_EARLY]: 'bulkToast.error.connection',
  [BulkOperationStreamErrorCode.OPERATION_CANCELLED]:
    'bulkToast.error.cancelled',
  [BulkOperationStreamErrorCode.OPERATION_FAILED]: 'bulkToast.error.failed',
} as const satisfies Record<BulkOperationStreamErrorCode, keyof typeof shellEn>;

/**
 * A bulk-operation stream error in the display language: the handler's coded
 * detail when it raised one, else built-in copy for the error code. The
 * English `error` text is never shown. Call at render or event time, not at
 * module load.
 */
export function bulkOperationErrorText(
  error: BulkOperationStreamError
): string {
  const text = i18next.t(STREAM_ERROR_KEYS[error.code], { ns: SHELL_NS });
  return codedErrorDetailText(error.detail, text);
}
